import { Clock } from 'lucide-react';
import { Card } from './Card';
import { TimestampDisplay } from './TimestampDisplay';
import { CopyButton } from './CopyButton';
import { formatTimestamp } from '../lib/utils';

interface PendingCommandsProps {
  cmds: Record<string, number> | undefined;
}

export const PendingCommands = ({ cmds }: PendingCommandsProps) => {
  if (!cmds || Object.keys(cmds).length === 0) return null;

  return (
    <Card title="Pending Commands" icon={Clock} className="bg-gray-750">
      <div className="space-y-2">
        {Object.entries(cmds).map(([cmd, timestamp]) => (
          <div key={cmd} className="flex items-center justify-between p-2 bg-gray-700 rounded text-sm group">
            <code className="text-yellow-400">{cmd}</code>
            <span className="flex items-center gap-1">
              <TimestampDisplay value={timestamp} />
              <CopyButton value={formatTimestamp(timestamp).full} />
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};
